import { render, staticRenderFns } from "./FundingRoundsListModal.vue?vue&type=template&id=38ce5dd5&scoped=true&"
import script from "./FundingRoundsListModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./FundingRoundsListModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ce5dd5",
  null
  
)

export default component.exports